

































import Vue from "vue";

interface Methods {
  close: () => void;
  navigateToNolaNovel: () => void;
}

export default Vue.extend<{}, Methods, {}, {}>({
  methods: {
    close() {
      this.$close(false);
    },
    navigateToNolaNovel() {
      const url = process.env.VUE_APP_NOLANOVEL_WEB;

      if (!url) {
        throw new Error("NolaノベルのWebサイトURLが環境変数に含まれていません。");
      }

      window.open(`${url}/auth/nola`, process.env.VUE_APP_NOLANOVEL_NAME ?? '');
    },
  },
});
